<p-toast
  *ngFor="let config of toastConfigs"
  [position]="position"
  [key]="config.key"
  [styleClass]="styleClass"
  [style]="{ width: toastWidth + 'px' }"
>
  <ng-template let-message pTemplate="message">
    <div class="min-w-[80%] max-w-[80%] flex items-center gap-2">
      <span class="w-full flex items-center gap-2">
        <img [src]="config.icon" [class]="config.iconWidth" />
        {{ message.summary }}
      </span>
    </div>
  </ng-template>
</p-toast>
